import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "data-radius",
  style: {borderRadius: '4px'}
}


import { defineComponent, defineProps } from 'vue'
import { getI18n } from '../utils'

const __default__ = defineComponent({
  name: 'CarrierCard'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  regionName: {
    type: String,
    require: true
  },
  continent: {
    type: String,
    require: true
  },
  carrier: {
    type: String,
    require: true
  },
  apn: {
    type: String,
    require: true
  },
  supportTiktok: {
    type: String,
    require: true
  }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      class: "card-row",
      gutter: 20,
      align: "middle"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 8,
          class: "col-title"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, { class: "mx-1" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getI18n)('地区', 'Region')) + ":", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 16 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, {
              class: "mx-1",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.regionName), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      class: "card-row",
      gutter: 20,
      align: "middle"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 8,
          class: "col-title"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, { class: "mx-1" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getI18n)('分类', 'Category')) + ":", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 16 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, {
              class: "mx-1",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.continent), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      class: "card-row",
      gutter: 20,
      align: "middle"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 8,
          class: "col-title"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, { class: "mx-1" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getI18n)('运营商', 'Carrier')) + ":", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 16 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, {
              class: "mx-1",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.carrier), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      class: "card-row",
      gutter: 20,
      align: "middle"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 8,
          class: "col-title"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, { class: "mx-1" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getI18n)('APN', 'APN')) + ":", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 16 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, {
              class: "mx-1",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.apn), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      class: "card-row",
      gutter: 20,
      align: "middle"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 8,
          class: "col-title"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, { class: "mx-1" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getI18n)('支持Tiktok', 'Support Tiktok')) + ":", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 16 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, {
              class: "mx-1",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.supportTiktok), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})